import { VisibilityAction, VisibilityDispatch } from '../../types/actions';

const SET_DELIVERY_MODAL = 'MODAL/SET_DELIVERY_MODAL';

export const setOpen = (visibility: boolean): VisibilityAction => ({
  type: SET_DELIVERY_MODAL,
  visibility,
});

export const open = () => (dispatch: VisibilityDispatch) => {
  dispatch(setOpen(true));
};

export const close = () => (dispatch: VisibilityDispatch) => {
  dispatch(setOpen(false));
};
